import { ReactNode, useEffect, useRef } from 'react';
import { Box, LinearProgress, SxProps } from '@mui/material';

interface CaptionedLinearLoaderProps {
  caption: ReactNode;
  sx?: SxProps;
  isScrollable?: boolean;
}

function CaptionedLinearLoader({
  caption,
  sx,
  isScrollable = false,
}: CaptionedLinearLoaderProps) {
  const boxRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (boxRef.current && isScrollable) {
      window.scrollTo({
        top: boxRef.current.offsetTop,
        behavior: 'smooth',
      });
    }
  }, []);

  return (
    <Box
      ref={boxRef}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        pt: '78px',
        pb: '38px',
        width: 'full',
        gap: 2,
        ...sx,
      }}
    >
      <LinearProgress
        sx={{
          width: '166px',
          height: '4px',
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            backgroundColor: 'grey.500',
          },
        }}
      />
      {caption}
    </Box>
  );
}

export default CaptionedLinearLoader;
